import { RequestMethod, RequestName, RequestProxy, useCaller } from '~/hydration/bridges';
import type { MultipleFetchFunction, SingleFetchFunction } from '~/units/core/managers';

export class PropertiesService {
  async fetchProperties(query = {}, body = {}) {
    try {
      return await useCaller(
        RequestProxy.S_AXON,
        RequestName.FETCH_PROPERTIES,
        'properties/matched',
        RequestMethod.POST,
        {
          ...query,
          is_neuron: true,
        },
        body,
      );
    } catch (e) {
      return {
        data: [],
        meta: {},
      };
    }
  }
}

// properties box section method to fetch properties with component configuration
export const fetchProperties: MultipleFetchFunction = async (
  limit: number,
  offset = 0,
  order: '-added_at' | string = '-added_at',
  filter = {},
  body,
) => {
  try {
    return await useCaller(
      RequestProxy.S_AXON,
      RequestName.FETCH_PROPERTIES,
      'properties/matched',
      RequestMethod.POST,
      {
        is_website: true,
        is_neuron: true,
        __limit: limit,
        __offset: offset,
        __order_by: order,
        ...filter,
      },
      body,
      {
        cacheMode: 'only-speed-optimisation',
      },
    );
  } catch (e) {
    return [];
  }
};

export const fetchProperty: SingleFetchFunction = async (id: string) => {
  try {
    return await useCaller(
      RequestProxy.S_AXON,
      RequestName.FETCH_PROPERTY,
      `properties/published/${id}`,
      RequestMethod.GET,
      {
        is_neuron: true,
      },
      {},
      {},
    );
  } catch (e) {
    return [];
  }
};
